import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "protocol-script" }
const _hoisted_2 = { class: "header-bar" }
const _hoisted_3 = { class: "search-bar" }
const _hoisted_4 = { class: "search-panel" }
const _hoisted_5 = { class: "script-list" }
const _hoisted_6 = { class: "card-header" }
const _hoisted_7 = { class: "script-title" }
const _hoisted_8 = { class: "card-actions" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "type-title" }
const _hoisted_12 = { class: "type-desc" }

import { ref } from 'vue'
import { DeleteOutlined } from '@ant-design/icons-vue'
import { protocolDataList } from '@/data/protocolData' // 导入协议数据

// 脚本类型选项

export default /*@__PURE__*/_defineComponent({
  __name: 'ProtocolScript',
  setup(__props) {

const scriptTypeValues = ['上报预处理', '上报后处理', '下发预处理', '下发后处理']
// 操作来源选项
const sourceValues = ['拓展', '网关子设备', '设备日志', '固件升级', '物模型']
// 操作类型选项 - 扩展
const opTypeValues = [
  '读取属性',
  '设置属性',
  '调用服务',
  '事件上报',
  '设备生命周期管理',
  '数据校验',
  '数据转换',
  '告警处理',
  '远程配置',
  '日志记录'
]

const scriptList = ref(
  protocolDataList.map((protocol, index) => ({
    id: index + 1,
    name: `${protocol.name}脚本`, // 使用协议名称作为脚本名称的一部分
    type: scriptTypeValues[Math.floor(Math.random() * scriptTypeValues.length)],
    source: sourceValues[Math.floor(Math.random() * sourceValues.length)],
    opType: opTypeValues[Math.floor(Math.random() * opTypeValues.length)],
    enabled: Math.random() < 0.7 // 70%的概率为启用
  }))
)

function toggleEnable(idx: number) {
  scriptList.value[idx].enabled = !scriptList.value[idx].enabled
}

const drawerOpen = ref(false)
const scriptForm = ref({
  name: '',
  type: 'up-pre',
  source: '',
  opType: '',
  desc: ''
})
const scriptTypeOptions = [
  { value: 'up-pre', label: '上报预处理', desc: '在设备属性上报时执行预处理操作' },
  { value: 'up-post', label: '上报后处理', desc: '在设备属性上报完成后执行操作' },
  { value: 'down-pre', label: '下发预处理', desc: '在设备属性下发时执行预处理操作' },
  { value: 'down-post', label: '下发后处理', desc: '在设备属性下发完成后执行操作' }
]
const sourceOptions = [
  // { value: '', label: '全部' }, // 创建时一般不选全部
  { value: 'expand', label: '拓展' },
  { value: 'gateway-sub', label: '网关子设备' },
  { value: 'log', label: '设备日志' },
  { value: 'ota', label: '固件升级' },
  { value: 'model', label: '物模型' }
]
const opTypeOptions = opTypeValues.map(op => ({ value: op, label: op })) // 从 opTypeValues 生成选项

function openDrawer() {
  drawerOpen.value = true
}
function closeDrawer() {
  drawerOpen.value = false
}
function selectScriptType(val: string) {
  scriptForm.value.type = val
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "page-title" }, "协议脚本", -1)),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: openDrawer
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("+ 创建脚本")
            ])),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_a_form, { layout: "inline" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, { label: "产品名称" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      placeholder: "请输入脚本名称",
                      style: {"width":"180px"}
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "脚本类型" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      placeholder: "请选择脚本类型",
                      style: {"width":"180px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: "" }, {
                          default: _withCtx(() => _cache[6] || (_cache[6] = [
                            _createTextVNode("全部")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "up-pre" }, {
                          default: _withCtx(() => _cache[7] || (_cache[7] = [
                            _createTextVNode("上报预处理")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "up-post" }, {
                          default: _withCtx(() => _cache[8] || (_cache[8] = [
                            _createTextVNode("上报后处理")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "down-pre" }, {
                          default: _withCtx(() => _cache[9] || (_cache[9] = [
                            _createTextVNode("下发预处理")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "down-post" }, {
                          default: _withCtx(() => _cache[10] || (_cache[10] = [
                            _createTextVNode("下发后处理")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "脚本状态" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      placeholder: "请选择脚本状态",
                      style: {"width":"180px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: "" }, {
                          default: _withCtx(() => _cache[11] || (_cache[11] = [
                            _createTextVNode("全部")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "enabled" }, {
                          default: _withCtx(() => _cache[12] || (_cache[12] = [
                            _createTextVNode("启用")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "disabled" }, {
                          default: _withCtx(() => _cache[13] || (_cache[13] = [
                            _createTextVNode("禁用")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "操作来源" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      placeholder: "请选择脚本来源",
                      style: {"width":"180px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: "" }, {
                          default: _withCtx(() => _cache[14] || (_cache[14] = [
                            _createTextVNode("全部")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "expand" }, {
                          default: _withCtx(() => _cache[15] || (_cache[15] = [
                            _createTextVNode("拓展")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "gateway-sub" }, {
                          default: _withCtx(() => _cache[16] || (_cache[16] = [
                            _createTextVNode("网关子设备")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "log" }, {
                          default: _withCtx(() => _cache[17] || (_cache[17] = [
                            _createTextVNode("设备日志")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "ota" }, {
                          default: _withCtx(() => _cache[18] || (_cache[18] = [
                            _createTextVNode("固件升级")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "model" }, {
                          default: _withCtx(() => _cache[19] || (_cache[19] = [
                            _createTextVNode("物模型")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      style: {"margin-right":"8px"}
                    }, {
                      default: _withCtx(() => _cache[20] || (_cache[20] = [
                        _createTextVNode("查询")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_button, null, {
                      default: _withCtx(() => _cache[21] || (_cache[21] = [
                        _createTextVNode("重置")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_a_row, { gutter: "16" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scriptList.value, (item, idx) => {
                return (_openBlock(), _createBlock(_component_a_col, {
                  span: 8,
                  key: item.id
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_card, { class: "script-card" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("span", _hoisted_7, "脚本名称：" + _toDisplayString(item.name), 1),
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_a_switch, {
                              checked: item.enabled,
                              "checked-children": "启用",
                              "un-checked-children": "启用",
                              onChange: () => toggleEnable(idx),
                              style: {"margin-right":"12px"}
                            }, null, 8, ["checked", "onChange"]),
                            _createVNode(_component_a_button, {
                              type: "text",
                              danger: ""
                            }, {
                              icon: _withCtx(() => [
                                _createVNode(_unref(DeleteOutlined))
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", null, "脚本类型: " + _toDisplayString(item.type), 1),
                          _createElementVNode("div", null, "操作来源: " + _toDisplayString(item.source), 1),
                          _createElementVNode("div", null, "操作类型: " + _toDisplayString(item.opType), 1)
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_a_drawer, {
      open: drawerOpen.value,
      title: "创建脚本",
      placement: "right",
      width: "700px",
      onClose: closeDrawer,
      closable: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          layout: "vertical",
          style: {"padding-right":"24px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "脚本名称",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: scriptForm.value.name,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((scriptForm.value.name) = $event)),
                  placeholder: "请输入脚本名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _cache[23] || (_cache[23] = _createElementVNode("div", { style: {"margin-bottom":"16px","font-weight":"bold"} }, "脚本类型", -1)),
            _createVNode(_component_a_row, {
              gutter: "16",
              style: {"margin-bottom":"24px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(scriptTypeOptions, (item) => {
                  return _createVNode(_component_a_col, {
                    span: 12,
                    key: item.value
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["script-type-card", { active: scriptForm.value.type === item.value }]),
                        onClick: ($event: any) => (selectScriptType(item.value))
                      }, [
                        _createElementVNode("div", _hoisted_11, _toDisplayString(item.label), 1),
                        _createElementVNode("div", _hoisted_12, _toDisplayString(item.desc), 1)
                      ], 10, _hoisted_10)
                    ]),
                    _: 2
                  }, 1024)
                }), 64))
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "选择来源",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: scriptForm.value.source,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((scriptForm.value.source) = $event)),
                  placeholder: "请选择来源"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sourceOptions, (item) => {
                      return _createVNode(_component_a_select_option, {
                        key: item.value,
                        value: item.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "操作类型",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: scriptForm.value.opType,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((scriptForm.value.opType) = $event)),
                  placeholder: "请选择操作类型"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(opTypeOptions), (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: item.value,
                        value: item.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "描述" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: scriptForm.value.desc,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((scriptForm.value.desc) = $event)),
                  placeholder: "请输入描述",
                  rows: "3"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  "html-type": "submit"
                }, {
                  default: _withCtx(() => _cache[22] || (_cache[22] = [
                    _createTextVNode("提交")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}
}

})